// ===================================================
// GAM Command Center — Lucide icons for slash commands
// ===================================================
//
// The catalog in slash-command-items.ts carries emoji/unicode icons ('📝',
// '𝗛₁', '☑️'). Those read fine in a labelled vertical list, but the quick
// bar shows icons ONLY — and a row of mixed emoji doesn't match the line-icon
// language the rest of our chrome uses (FloatingToolbar, Sidebar). This maps
// every command to the same Lucide set so the bar looks like the toolbar it
// sits next to.
//
// Keyed by the command's English `title`, which is the stable identifier in
// the catalog (titleHe is display text and gets reworded).

import {
  Type,
  Heading1,
  Heading2,
  Heading3,
  List,
  ListOrdered,
  ListChecks,
  ChevronRight,
  Image,
  Paperclip,
  Code2,
  Table,
  Info,
  TriangleAlert,
  Lightbulb,
  Quote,
  Minus,
  Link2,
  TextCursorInput,
  SquareCheck,
  ChevronDownSquare,
  Calendar,
  Tags,
  Globe,
  type LucideIcon,
} from 'lucide-react';

export const SLASH_COMMAND_ICONS: Record<string, LucideIcon> = {
  Paragraph: Type,
  'Heading 1': Heading1,
  'Heading 2': Heading2,
  'Heading 3': Heading3,
  'Bullet List': List,
  'Numbered List': ListOrdered,
  Checklist: ListChecks,
  Toggle: ChevronRight,
  'Toggle H1': ChevronRight,
  'Toggle H2': ChevronRight,
  'Toggle H3': ChevronRight,
  Image: Image,
  File: Paperclip,
  Embed: Globe,
  Table: Table,
  'Callout — Info': Info,
  'Callout — Warning': TriangleAlert,
  'Callout — Tip': Lightbulb,
  'Code Block': Code2,
  Quote: Quote,
  Divider: Minus,
  'Object Reference': Link2,
  'Text Field': TextCursorInput,
  'Checkbox Form Field': SquareCheck,
  'Dropdown Field': ChevronDownSquare,
  'Date Field': Calendar,
  'Tags Field': Tags,
};

/** Falls back to a neutral glyph so a newly added command still renders. */
export function iconForCommand(title: string): LucideIcon {
  return SLASH_COMMAND_ICONS[title] ?? Type;
}
